import { useEffect, useRef, useState } from "react"
import { useRegisterSW } from "virtual:pwa-register/react"
import { toast } from "sonner"

export function PWAUpdatePrompt() {
  const toastIdRef = useRef<string | number | null>(null)
  const [isDismissed, setIsDismissed] = useState(false)

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  // biome-ignore lint/correctness/useExhaustiveDependencies: reset dismissal when a new version arrives
  useEffect(() => {
    setIsDismissed(false)
  }, [needRefresh])

  useEffect(() => {
    if (!needRefresh || isDismissed) return

    toastIdRef.current = toast("Nova versão disponível", {
      description: "Atualize para obter melhorias e correções.",
      duration: Number.POSITIVE_INFINITY,
      action: {
        label: "Atualizar",
        onClick: () => {
          updateServiceWorker(true)
        },
      },
      cancel: {
        label: "Agora não",
        onClick: () => {
          setIsDismissed(true)
        },
      },
    })

    return () => {
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current)
      }
    }
  }, [needRefresh, isDismissed, updateServiceWorker])

  return null
}
